import { twMerge } from 'tailwind-merge';

import { getRewardsToDisplay } from '../utils';
import { RewardPill } from './RewardPill';

type RewardsListProps = {
  rewards?: string[];
  className?: string;
};

export const RewardsList = ({ rewards, className }: RewardsListProps) => {
  const rewardsToDisplay = getRewardsToDisplay(rewards);

  if (rewardsToDisplay.length === 0) {
    return null;
  }

  return (
    <div className={twMerge('tw-flex tw-gap-[10px]', className)}>
      {rewardsToDisplay.map(({ reward, flex }, index) => (
        <RewardPill key={index} reward={reward} flex={flex} />
      ))}
    </div>
  );
};
